<template>
  <b-modal size="lg" centered id="modal-fiche" ref="modalFiche" @close="closeModal">
    <template #modal-header>
      <h4>Création d’un dossier </h4>
    </template>
    <b-card no-body>
      <b-card-body>
        <b-form id="fiche-form">
          <b-row>
            <b-col sm="6">
              <b-card no-body>
                <div class="card-smallHeader card-header-action mb-2">
                  <span style="color: #d9418b" class="mr-2"><b> BENEFICIARE</b></span>
                </div>
                <b-card-body>
                  <b-row class="mb-2">
                    <b-col sm="3">
                      <label for="nom"><strong>Nom </strong></label>
                    </b-col>
                    <b-col>
                      <span>{{ donnees.beneficiaire.nom }}</span>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col sm="3">
                      <label for="prenom"><strong>Prénom </strong></label>
                    </b-col>
                    <b-col>
                      <span>{{ donnees.beneficiaire.prenom }}</span>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col sm="3">
                      <label for="siren"><strong>N° SS </strong></label>
                    </b-col>
                    <b-col>
                      <span>{{ donnees.beneficiaire.nir }}</span>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
            <b-col sm="6">
              <b-card no-body>
                <div class="card-smallHeader card-header-action mb-2">
                  <span style="color: #d9418b" class="mr-2"><b> EMPLOYEUR</b></span>
                </div>
                <b-card-body>
                  <b-row class="mb-1">
                    <b-col class="rs">
                      <label for="raison_sociale"><strong>Raison Social</strong></label>
                    </b-col>
                    <b-col>
                      <span>{{ donnees.structure.rs }}</span>
                    </b-col>
                  </b-row>
                  <b-row class="mb-1">
                    <b-col sm="2">
                      <label for="siren"><strong>SIREN </strong></label>
                    </b-col>
                    <b-col sm="4">
                      <span>{{ donnees.structure.siren }}</span>
                    </b-col>
                    <b-col sm="2">
                      <label for="nic"><strong>NIC </strong></label>
                    </b-col>
                    <b-col sm="3">
                      <span>{{ donnees.structure.nic }}</span>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
            <b-col sm="6">
              <b-card no-body>
                <div class="card-smallHeader card-header-action mb-2">
                  <span style="color: #d9418b" class="mr-2"><b> PRECISIONS SUR LE PRODUIT</b></span>
                </div>
                <b-card-body>
                  <b-row class="mb-2">
                    <b-col sm="4">
                      <label for="type"><strong>Produit : </strong></label>
                    </b-col>
                    <b-col>
                      <span>{{ donnees.selectedProduct }}</span>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col sm="4">
                      <label for="type"><strong>Garantie </strong></label>
                    </b-col>
                    <b-col>
                      <span>{{ donnees.selectedGarantie }}</span>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
            <b-col sm="6">
              <b-card no-body>
                <div class="card-smallHeader card-header-action mb-2">
                  <span style="color: #d9418b" class="mr-2"><b> CONTACT</b></span>
                </div>
                <b-card-body>
                  <b-row class="mb-1">
                    <b-col sm="3">
                      <label for="nom"><strong>Nom</strong></label>
                    </b-col>
                    <b-col>
                      <span>{{ donnees.contact.nom }}</span>
                    </b-col>
                  </b-row>
                  <b-row class="mb-1">
                    <b-col sm="3">
                      <label for="nom"><strong>Email</strong></label>
                    </b-col>
                    <b-col>
                      <span>{{ donnees.contact.email }}</span>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
            <b-col sm="12">
              <b-card no-body>
                <div class="card-smallHeader card-header-action mb-2">
                  <span style="color: #d9418b" class="mr-2"><b> OBJET DE LA DEMANDE CLIENTE</b></span>
                </div>
                <b-card-body>
                  <b-row class="mb-1">
                    <b-col>
                      <b-form-textarea rows="6" max-rows="6" id="demandeObjet" v-model="donnees.demande_objet"/>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>
    <template #modal-footer>
      <div class="w-100">
        <b-button size="md" variant="primary" class="float-right" @click="save" :disabled="!donnees.demande_objet"><i class="fa fa-save"></i> Enregistrer</b-button>
        <b-button size="md" variant="secondary" class="mr-2 float-right" @click="closeModal">Annuler</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  export default {
    name: "ModalFicheClientDossier",
    methods: {
      openModal() {
        this.$refs.modalFiche.show()
      },
      closeModal() {
        this.$refs.modalFiche.hide()
      },
      save() {
        if(this.donnees.demande_objet){
          //Début de la création de dossier
          this.$store.commit('IS_LOADING', true)
          let dataPost = {}
          dataPost.fiche_id = this.donnees.fiche_id
          dataPost.beneficiaire_nom = this.donnees.beneficiaire.nom
          dataPost.beneficiaire_prenom = this.donnees.beneficiaire.prenom
          dataPost.beneficiaire_nir = this.donnees.beneficiaire.nir
          dataPost.structure_rs = this.donnees.structure.rs
          dataPost.structure_siren = this.donnees.structure.siren
          dataPost.structure_nic = this.donnees.structure.nic
          dataPost.contact_nom = this.donnees.contact.nom
          dataPost.contact_tel = this.donnees.contact.tel
          dataPost.contact_email = this.donnees.contact.email
          dataPost.famille_produit_id = this.donnees.produitId
          dataPost.garantie = this.donnees.selectedGarantie
          dataPost.demande_objet = this.donnees.demande_objet
          dataPost.demandeClientNum = this.donnees.demandeClientNum
          this.$axios.post('/espaceRelationClient/fiche/dossier/create', dataPost)
            .then(response => {
              console.log(response.dossier)
              this.$swal({ position: 'top', type: 'success', title: 'Succès', text: "Création dossier effectuée avec succès", showConfirmButton: false, timer: 5000 })
              this.$router.push({path: "/espace-rc/fiches-niveau2"})
              this.$store.commit('IS_LOADING', false)
            })
            .catch(error => {
              console.log(error)
              self.$store.commit('IS_LOADING', false)
              self.$swal({ position: 'top', type: 'error', title: 'Attention !!', text: 'Une erreur est survenue pendant la suppression. Si le problème persiste contactez le support DOSI.', showConfirmButton: false, timer: 5000 })
            })

        }

        return false;
      }
    },
    props: {
      donnees: {
        type: Object,
        default: null
      }
    },
  }
</script>

<style>
.hidden {
  display: none;
}
.rs {
  max-width: 35%
}
</style>
